  (function () {
    'use strict';

    var drawer = document.getElementById('WSCartDrawer');
    var overlay = document.getElementById('WSCartDrawerOverlay');
    if (!drawer || !overlay) return;

    /* Membership tier (from Liquid). Silver & Gold members (Joy tier) get free
       local delivery with no order minimum — see the threshold override below. */
    var IS_MEMBER = (typeof window !== "undefined" && window.WSD_IS_MEMBER === true);

    /* ======================================================================
       CONFIG — EDIT ME. Mirrors the store's Shopify Local Delivery zones
       (Settings → Shipping → Local delivery), which are radius-based:
       we resolve a ZIP to its centroid, measure straight-line distance from
       the shop, and match the first zone whose radius contains it — the same
       way Shopify's radius zones decide who gets local delivery.

       • STORE_COORDS — 142 W Sibley Blvd, Dolton, IL 60419
       • DELIVERY_ZONES — one zone (since 2026-10-15): everywhere within 8 mi,
         free delivery on orders $50+. Radius + minimum order (cents) must
         match the zone configured in Shopify admin.
       • SHIP_FREE_THRESHOLD — free standard shipping over this (cents).
       • ZIP_COORDS — centroids for every ZIP within ~12 mi of the store
         (generated from US ZIP data; IL + IN). A ZIP missing from this map
         is definitively outside the 8-mi delivery radius → standard shipping.
       ====================================================================== */
    var STORE_COORDS = [41.6389, -87.6070];
    var DELIVERY_ZONES = [
      { id: 'local', maxMiles: 8, minOrder: 5000,
        zoneLabel: 'Local Delivery (within 8 mi)',
        shortLabel: 'Same-Day Local Delivery',
        statusClass: 'is-gold',
        perk: 'Free Same-Day Local Delivery', minText: 'Free on orders $50+' }
    ];
    var SHIP_FREE_THRESHOLD = 9900; /* free IL shipping on $99+ (2026-10-16); $9.99 flat under */
    var ZIP_COORDS = {'60419':[41.6257,-87.598],'60827':[41.6496,-87.6301],'60473':[41.5979,-87.5938],'60633':[41.6642,-87.5612],'60426':[41.6103,-87.6534],'60409':[41.6153,-87.5483],'60628':[41.6934,-87.6243],'60406':[41.6582,-87.6795],'60469':[41.6277,-87.6872],'60476':[41.5727,-87.6078],'46327':[41.6327,-87.5113],'60643':[41.6996,-87.6628],'60428':[41.5998,-87.6906],'60472':[41.6423,-87.7089],'46320':[41.6099,-87.5079],'60438':[41.566,-87.5446],'60429':[41.5738,-87.6849],'46394':[41.6787,-87.5005],'60655':[41.6948,-87.7038],'60425':[41.5467,-87.6126],'60430':[41.5556,-87.6616],'60617':[41.7257,-87.556],'46324':[41.584,-87.5034],'60445':[41.635,-87.7362],'60418':[41.6446,-87.7415],'60803':[41.6721,-87.7357],'60619':[41.7458,-87.6054],'46312':[41.6349,-87.4627],'60620':[41.7411,-87.6543],'60805':[41.722,-87.7024],'60422':[41.5406,-87.6837],'60452':[41.6077,-87.7542],'60478':[41.5637,-87.7247],'46321':[41.5544,-87.5011],'46323':[41.5878,-87.4532],'60649':[41.762,-87.5703],'60411':[41.5087,-87.5904],'60456':[41.7311,-87.7315],'60453':[41.7143,-87.7516],'60652':[41.7454,-87.7135],'60412':[41.5061,-87.6356],'60461':[41.5134,-87.6742],'60621':[41.775,-87.6421],'60463':[41.6621,-87.7927],'60415':[41.7017,-87.7774],'60637':[41.7813,-87.6051],'60482':[41.6895,-87.7863],'46322':[41.55,-87.4569],'60636':[41.776,-87.6674],'60629':[41.7781,-87.7069],'60477':[41.5825,-87.805],'46406':[41.5878,-87.4062],'60459':[41.7447,-87.7699],'60443':[41.5102,-87.7406],'60615':[41.8022,-87.6006],'46311':[41.492,-87.5108],'60466':[41.479,-87.6828],'60475':[41.4686,-87.6386],'46319':[41.5335,-87.4228]};

    var STORAGE_KEY = 'wsDeliveryZip';
    var CURRENCY = drawer.getAttribute('data-currency') || 'USD';
    var currentTotal = parseInt(drawer.getAttribute('data-cart-total'), 10) || 0;

    /* Delivery mode drives the progress-bar target + copy.
       'idle' = no ZIP checked yet → neutral prompt, no dollar claims. */
    var deliveryMode = 'idle';
    var MODES = {
      local:      { threshold: 5000,  perk: 'Free Same-Day Local Delivery', icon: 'fa-truck-fast' },
      standard:   { threshold: SHIP_FREE_THRESHOLD, perk: 'Free Shipping', icon: 'fa-box-open' }
    };
    DELIVERY_ZONES.forEach(function (z) { if (MODES[z.id]) MODES[z.id].threshold = z.minOrder; });
    /* Silver & Gold: free local delivery anywhere in the zone, no order minimum. */
    if (IS_MEMBER) { MODES.local.threshold = 0; }

    var itemsEl = drawer.querySelector('[data-wsd-items]');
    var progressEl = drawer.querySelector('[data-wsd-progress]');
    var progressMsg = drawer.querySelector('[data-wsd-progress-msg]');
    var progressFill = drawer.querySelector('[data-wsd-progress-fill]');
    var subtotalEl = drawer.querySelector('[data-wsd-subtotal]');
    var pointsEl = drawer.querySelector('[data-wsd-points]');
    var pointsWrap = drawer.querySelector('[data-wsd-points-wrap]');
    var countEl = drawer.querySelector('[data-wsd-count]');
    var zipView = drawer.querySelector('[data-wsd-zip-view]');
    var zipViewText = drawer.querySelector('[data-wsd-zip-view-text]');
    var zipEdit = drawer.querySelector('[data-wsd-zip-edit]');
    var zipInput = drawer.querySelector('[data-wsd-zip-input]');
    var zipError = drawer.querySelector('[data-wsd-zip-error]');
    var lastFocus = null;
    var busy = false;

    var fmt;
    try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }); } catch (e) { fmt = null; }
    function money(cents) {
      return fmt ? fmt.format(cents / 100) : '$' + (cents / 100).toFixed(2);
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function setBusy(state) {
      busy = state;
      drawer.classList.toggle('is-busy', state);
    }

    /* ---------- Zone resolution (Shopify-style radius logic) ---------- */
    function milesBetween(a, b) {
      var R = 3958.8;
      var toRad = function (d) { return d * Math.PI / 180; };
      var dLat = toRad(b[0] - a[0]);
      var dLon = toRad(b[1] - a[1]);
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    /* Returns { zone, miles } for a local-delivery ZIP, or { zone: null }.
       A zone flagged memberOnly would be skipped for non-members (none are). */
    function resolveZone(zip) {
      var coords = ZIP_COORDS[zip];
      if (!coords) return { zone: null, miles: null };
      var d = milesBetween(STORE_COORDS, coords);
      for (var i = 0; i < DELIVERY_ZONES.length; i++) {
        if (DELIVERY_ZONES[i].memberOnly && !IS_MEMBER) continue;
        if (d <= DELIVERY_ZONES[i].maxMiles) return { zone: DELIVERY_ZONES[i], miles: d };
      }
      return { zone: null, miles: d };
    }

    /* ---------- Open / close ---------- */
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('wsd-lock');
      var closeBtn = drawer.querySelector('[data-wsd-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('wsd-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    /* ---------- Rendering ---------- */
    function lineHTML(item) {
      var img = '';
      if (item.image) {
        var sep = item.image.indexOf('?') === -1 ? '?' : '&';
        img = '<img src="' + esc(item.image + sep + 'width=200') + '" alt="' + esc(item.product_title) + '" width="64" height="92" loading="lazy">';
      }
      var variant = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variant = '<p class="wsd-line__variant">' + esc(item.variant_title) + '</p>';
      }
      var compare = '';
      if (item.original_line_price > item.final_line_price) {
        compare = '<span class="wsd-line__compare">' + esc(money(item.original_line_price)) + '</span>';
      }
      return (
        '<div class="wsd-line" data-key="' + esc(item.key) + '">' +
          '<a class="wsd-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="wsd-line__info">' +
            '<a class="wsd-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            variant +
            '<p class="wsd-line__unit">' + esc(money(item.final_price)) + ' each</p>' +
            '<div class="wsd-line__controls">' +
              '<div class="wsd-qty" data-wsd-qty>' +
                '<button type="button" class="wsd-qty__btn" data-wsd-minus aria-label="Decrease quantity"><i class="fa-solid fa-minus" aria-hidden="true"></i></button>' +
                '<input class="wsd-qty__input" data-wsd-qty-input type="number" inputmode="numeric" min="0" value="' + item.quantity + '" aria-label="Quantity">' +
                '<button type="button" class="wsd-qty__btn" data-wsd-plus aria-label="Increase quantity"><i class="fa-solid fa-plus" aria-hidden="true"></i></button>' +
              '</div>' +
              '<button type="button" class="wsd-remove" data-wsd-remove aria-label="Remove ' + esc(item.product_title) + '"><i class="fa-regular fa-trash-can" aria-hidden="true"></i></button>' +
            '</div>' +
          '</div>' +
          '<div class="wsd-line__prices">' + compare + '<span class="wsd-line__price">' + esc(money(item.final_line_price)) + '</span></div>' +
        '</div>'
      );
    }

    function renderProgress() {
      if (deliveryMode === 'idle') {
        progressEl.classList.add('is-idle');
        progressEl.classList.remove('is-unlocked');
        progressFill.style.width = '0%';
        progressMsg.innerHTML =
          '<i class="fa-solid fa-location-dot" aria-hidden="true"></i>Enter your ZIP to see delivery options for your area.';
        return;
      }
      progressEl.classList.remove('is-idle');
      var m = MODES[deliveryMode] || MODES.standard;
      var target = m.threshold;
      var pct = target > 0 ? Math.min(100, Math.round((currentTotal / target) * 100)) : 100;
      progressFill.style.width = pct + '%';
      if (currentTotal >= target) {
        progressEl.classList.add('is-unlocked');
        progressMsg.innerHTML =
          '<i class="fa-solid fa-champagne-glasses" aria-hidden="true"></i>You have unlocked <b>' + m.perk + '!</b>';
      } else {
        progressEl.classList.remove('is-unlocked');
        progressMsg.innerHTML =
          '<i class="fa-solid ' + m.icon + '" aria-hidden="true"></i>You are <b>' + esc(money(target - currentTotal)) + '</b> away from <b>' + m.perk + '!</b>';
      }
    }

    function render(cart) {
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      countEl.textContent = cart.item_count;
      subtotalEl.textContent = money(cart.total_price);
      currentTotal = cart.total_price;
      /* Points this order: $1 = 1 point; under 50 cents rounds down, 50 cents and up rounds up. */
      var orderPoints = Math.floor(((cart.total_price || 0) + 50) / 100);
      if (pointsEl) pointsEl.textContent = orderPoints.toLocaleString('en-US');
      if (pointsWrap) pointsWrap.hidden = orderPoints <= 0;
      renderProgress();
      itemsEl.innerHTML = cart.items.map(lineHTML).join('');
      /* Sync the header badge(s) */
      var badges = document.querySelectorAll('[data-wsl-cart-count], .wsl-cart-count');
      for (var i = 0; i < badges.length; i++) badges[i].textContent = cart.item_count;
    }

    /* ---------- Header "Deliver to" ZIP sync ---------- */
    /* Reflect the chosen ZIP in every header "Deliver to" button so the header
       and the cart drawer always show the same delivery ZIP. */
    function updateHeaderLabels(zip) {
      var labels = document.querySelectorAll('.wsl-deliver .wsl-deliver-text b');
      for (var i = 0; i < labels.length; i++) {
        labels[i].textContent = zip ? zip : 'Enter ZIP';
      }
    }
    function closeHeaderPops() {
      var pops = document.querySelectorAll('.ws-zippop');
      for (var i = 0; i < pops.length; i++) pops[i].hidden = true;
    }
    /* Turn the header's "Deliver to / Enter ZIP" button into a working ZIP
       entry: clicking it opens a small popover; saving a valid ZIP applies it
       to the drawer (zone + progress) and carries it over via applyZip. */
    function initHeaderZip() {
      var btns = document.querySelectorAll('.wsl-deliver');
      for (var i = 0; i < btns.length; i++) {
        (function (btn) {
          if (btn.dataset.wsZipInit) return;
          btn.dataset.wsZipInit = '1';

          var wrap = document.createElement('span');
          wrap.className = 'ws-zipwrap';
          btn.parentNode.insertBefore(wrap, btn);
          wrap.appendChild(btn);

          var pop = document.createElement('div');
          pop.className = 'ws-zippop';
          pop.hidden = true;
          pop.innerHTML =
            '<div class="ws-zippop__t">Enter your delivery ZIP</div>' +
            '<div class="ws-zippop__row">' +
              '<input class="ws-zippop__input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" placeholder="e.g. 60419" aria-label="Delivery ZIP">' +
              '<button type="button" class="ws-zippop__save">Save</button>' +
            '</div>' +
            '<div class="ws-zippop__note" aria-live="polite"></div>';
          wrap.appendChild(pop);

          var input = pop.querySelector('.ws-zippop__input');
          var saveBtn = pop.querySelector('.ws-zippop__save');
          var note = pop.querySelector('.ws-zippop__note');

          function commit() {
            var z = (input.value || '').replace(/\D/g, '');
            if (z.length !== 5) {
              note.className = 'ws-zippop__note is-err';
              note.textContent = 'Enter a valid 5-digit ZIP.';
              return;
            }
            applyZip(z, true);
            var res = resolveZone(z);
            note.className = 'ws-zippop__note is-ok';
            note.textContent = res.zone ? (res.zone.shortLabel + ' available in your area.') : 'Standard shipping to your area.';
            setTimeout(function () { pop.hidden = true; }, 1100);
          }

          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var willOpen = pop.hidden;
            closeHeaderPops();
            if (willOpen) {
              pop.hidden = false;
              var cur = '';
              try { cur = window.localStorage.getItem(STORAGE_KEY) || ''; } catch (er) {}
              input.value = cur;
              note.textContent = '';
              note.className = 'ws-zippop__note';
              input.focus();
            }
          });
          saveBtn.addEventListener('click', commit);
          input.addEventListener('input', function () {
            input.value = input.value.replace(/\D/g, '').slice(0, 5);
            note.textContent = '';
            note.className = 'ws-zippop__note';
          });
          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); commit(); }
          });
        })(btns[i]);
      }
      document.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('.ws-zipwrap')) closeHeaderPops();
      });
    }

    /* ---------- ZIP row: quiet 1-line view ⇄ inline edit ---------- */
    function showZipEdit(focusInput) {
      if (zipView) zipView.hidden = true;
      if (zipEdit) zipEdit.hidden = false;
      if (focusInput && zipInput) zipInput.focus();
    }
    function showZipView(zip, zone) {
      if (!zipView || !zipViewText) return;
      if (zipEdit) zipEdit.hidden = true;
      if (zipError) zipError.hidden = true;
      zipView.hidden = false;
      var status = zone
        ? '<span class="wsd-zip__status ' + zone.statusClass + '">' + esc(zone.shortLabel) + '</span>'
        : '<span class="wsd-zip__status">Standard Shipping</span>';
      zipViewText.innerHTML = '📍 Delivering to <b>' + esc(zip) + '</b> · ' + status;
    }

    function persistZipAttribute(zip, zoneName) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery ZIP': zip, 'Delivery Zone': zoneName } })
      }).catch(function () { /* non-blocking */ });
    }

    /* Apply a validated 5-digit ZIP: resolve zone, set mode, collapse to the
       1-line view, retarget progress, sync the header label, store. persist=true
       also writes the Shopify cart attributes (skipped on localStorage rehydrate). */
    function applyZip(zip, persist) {
      zip = String(zip).replace(/\D/g, '').slice(0, 5);
      if (zip.length !== 5) return false;

      var res = resolveZone(zip);
      deliveryMode = res.zone ? res.zone.id : 'standard';

      if (zipInput) zipInput.value = zip;
      if (zipError) zipError.hidden = true;
      showZipView(zip, res.zone);
      renderProgress();
      updateHeaderLabels(zip);

      try { window.localStorage.setItem(STORAGE_KEY, zip); } catch (e) {}
      if (persist) {
        persistZipAttribute(zip, res.zone ? res.zone.zoneLabel : 'Standard Shipping');
      }
      return true;
    }

    function handleZipCheck() {
      var raw = zipInput ? zipInput.value.replace(/\D/g, '') : '';
      if (raw.length !== 5) {
        if (zipError) zipError.hidden = false;
        return;
      }
      applyZip(raw, true);
    }

    /* ---------- Cart API ---------- */
    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      });
    }
    function refresh(openAfter) {
      return fetchCart()
        .then(function (cart) {
          render(cart);
          if (openAfter) open();
          return cart;
        })
        .catch(function () { /* leave current state */ });
    }
    function change(key, quantity) {
      if (busy) return;
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart change failed');
          return r.json();
        })
        .then(render)
        .catch(function () { refresh(false); })
        .then(function () { setBusy(false); });
    }

    /* ---------- Drawer interactions (event delegation) ---------- */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-wsd-close]')) { close(); return; }
      if (e.target.closest('[data-wsd-zip-check]')) { handleZipCheck(); return; }
      if (e.target.closest('[data-wsd-zip-change]')) { showZipEdit(true); return; }
      var line = e.target.closest('.wsd-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-wsd-qty-input]');
      var qty = parseInt(input && input.value, 10) || 0;
      if (e.target.closest('[data-wsd-plus]')) change(key, qty + 1);
      else if (e.target.closest('[data-wsd-minus]')) change(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-wsd-remove]')) change(key, 0);
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-wsd-qty-input]');
      if (!input) return;
      var line = input.closest('.wsd-line');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      change(line.getAttribute('data-key'), qty);
    });

    /* ZIP field: keep it numeric; Enter triggers the check. */
    if (zipInput) {
      zipInput.addEventListener('input', function () {
        zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
        if (zipError) zipError.hidden = true;
      });
      zipInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); handleZipCheck(); }
      });
    }

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      /* Minimal focus trap */
      var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------- Hijack cart links (header cart icon etc.) ---------- */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.hasAttribute('data-wsd-bypass') || a.closest('.wsd')) return;
      var url;
      try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (!/(^|\/)cart\/?$/.test(url.pathname)) return;
      e.preventDefault();
      open();
      refresh(false);
    }, true);

    /* ---------- Hijack add-to-cart forms → AJAX + open drawer ---------- */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopPropagation();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'add failed');
            return data;
          });
        })
        .then(function () { return refresh(true); })
        .catch(function (err) { window.alert(err.message || 'Could not add to cart.'); })
        .then(function () { if (submitBtn) submitBtn.disabled = false; });
    }, true);

    /* ---------- Interop: other scripts can trigger us ---------- */
    document.addEventListener('cart:refresh', function () { refresh(false); });
    document.addEventListener('cart:update', function () { refresh(true); });
    window.WSCartDrawer = {
      open: open,
      close: close,
      refresh: refresh,
      setZip: function (z) { return applyZip(z, true); }
    };

    /* ---------- Wire the header "Deliver to" ZIP button ---------- */
    initHeaderZip();

    /* ---------- Rehydrate stored ZIP on load ---------- */
    (function initZip() {
      var stored = null;
      try { stored = window.localStorage.getItem(STORAGE_KEY); } catch (e) {}
      if (stored && /^\d{5}$/.test(stored)) {
        applyZip(stored, false);   /* restores 1-line view + zone + target + header label */
      }
    })();
  })();
